import { Api } from '@/api/api.client';
import type { Components } from '@/api/generated/api';
import { FilterOperationType, type IFilter } from '@chax-at/prisma-filter-common';
import type { ISchoolSubjectGroupFilter } from 'common/interface/filter.interface';

const baseOrderFilter: IFilter<ISchoolSubjectGroupFilter> = {
  order: [
    { field: 'order', dir: 'asc' },
    { field: 'createdAt', dir: 'asc' },
  ],
};

export async function fetchProviderSchoolSubjectGroupTemplates(params: {
  templateSetId: number;
  schoolLevel?: number;
}): Promise<Components.Schemas.SchoolSubjectGroupDto[]> {
  const filter: IFilter<ISchoolSubjectGroupFilter> = {
    ...baseOrderFilter,
    filter: [{ field: 'templateSetId', type: FilterOperationType.Eq, value: params.templateSetId }],
  };

  if (params.schoolLevel != null) {
    filter.filter = [
      ...(filter.filter ?? []),
      { field: 'schoolLevel', type: FilterOperationType.Eq, value: params.schoolLevel },
    ];
  }

  const res = await Api.Routes.SchoolSubjectGroupProvider.listProviderTemplates({ $filter: filter });
  return res.rows;
}

export async function createProviderSchoolSubjectGroupTemplate(params: {
  dto: Components.Schemas.CreateSchoolSubjectGroupProviderDto;
}): Promise<Components.Schemas.SchoolSubjectGroupDto> {
  const res = await Api.Routes.SchoolSubjectGroupProvider.createProviderTemplate({}, params.dto);
  return res.data;
}

export async function assignProviderSubjectsToGroup(params: {
  groupId: number;
  dto: Components.Schemas.AssignSubjectDto;
}): Promise<void> {
  await Api.Routes.SchoolSubjectGroupProvider.assignProviderSubjects({ groupId: params.groupId }, params.dto);
}

export async function unassignProviderSubjectsFromGroup(params: {
  groupId: number;
  dto: Components.Schemas.UnassignSubjectDto;
}): Promise<void> {
  await Api.Routes.SchoolSubjectGroupProvider.unassignProviderSubjects({ groupId: params.groupId }, params.dto);
}

export async function reorderProviderUnassignedSubjects(params: {
  dto: Components.Schemas.ReorderUnassignedSubjectDto;
}): Promise<void> {
  await Api.Routes.SchoolSubjectGroupProvider.reorderProviderUnassignedSubjects(null, params.dto);
}
